import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchMyProfile, profileKeys, updateMyProfile } from '../api';
import type { ParticipantUpdate } from '@shared/schemas/participants';

export function useMyProfile() {
  return useQuery({
    queryKey: profileKeys.me(),
    queryFn: fetchMyProfile,
    staleTime: 60_000,
    retry: (failureCount, err) => {
      // No reintentar si es un NotFoundError (trigger aún no ha creado el participant)
      if (err instanceof Error && err.message.includes('not found')) return failureCount < 3;
      return failureCount < 2;
    },
    retryDelay: 500,
  });
}

export function useUpdateMyProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ParticipantUpdate) => updateMyProfile(input),
    onSuccess: (data) => {
      qc.setQueryData(profileKeys.me(), data);
      // Tu nombre/avatar aparece en muchas vistas (miembros, gastos, actividad,
      // inicio). Invalida las que lo muestran para que no salga el valor viejo.
      void qc.invalidateQueries({ queryKey: ['groups'] });
      void qc.invalidateQueries({ queryKey: ['expenses'] });
      void qc.invalidateQueries({ queryKey: ['activity'] });
      void qc.invalidateQueries({ queryKey: ['home'] });
    },
  });
}
